// Models
import { PROFILE_TYPES } from '@/models/AccountProfile'
import Payment, { PAYMENT_CHANNELS } from '@/models/Payment'

export default {
  computed: {
    accountOptions () {
      return this.profile.accounts
        .filter(account => account.profileCustomerWallet)
        .map(account => ({
          'name': account.name + ` (${account.accountId})`,
          'value': account.accountId
        }))
    },
    allowedPaymentChannels () {
      return [
        // PAYMENT_CHANNELS.BILDER_ACCOUNT, // For testing multiple IBANs
        PAYMENT_CHANNELS.BANK_OF_LITHUANIA
      ]
    },
    channelOptions () {
      const options = []
      if (this.masterAccountId) {
        const account = this.profile.accounts.find(({ accountId }) => accountId === this.masterAccountId)
        Payment.channelOptions.forEach((channelOption) => {
          if (
            account.allowedIncomingChannels.includes(channelOption.value) &&
              this.allowedPaymentChannels.includes(channelOption.value)
          ) {
            options.push(channelOption)
          }
        })
      }

      return options
    },
    customerType () {
      return this.form.type
    },
    isLegalType () {
      return this.customerType === PROFILE_TYPES.LEGAL
    },
    fieldLabels () {
      return {
        name: this.isLegalType ? 'Company Name' : 'Full Name',
        regNumber: this.isLegalType ? 'Registration Number' : 'ID Number',
        registrationDate: this.isLegalType ? 'Company Registration Date' : 'Date of Birth',
        citizenship: this.isLegalType ? 'Country of Registration' : 'Citizenship'
      }
    },
    masterAccountId () {
      return this.form.accountId
    },
    masterAccountInfo () {
      return this.getMasterAccountInfo(this.masterAccountId)
    }
  },
  methods: {
    getFieldLabel (field, defaultValue) {
      return this.fieldLabels[field] || defaultValue
    },
    getOptionalDate (dateValue, defaultValue = '—') {
      return (dateValue != null && dateValue !== '') ? this.$options.filters.date(dateValue) : defaultValue
    },
    getOptionalValue (value, defaultValue = '—') {
      return (value != null && value !== '') ? value : defaultValue
    },
    getMasterAccountInfo (accountId) {
      const account = this.profile.accounts.find(account => account.accountId === accountId)
      if (account) {
        return `${account.name} (${account.accountId})`
      }
      return 'error'
    }
  }
}
